import { t } from 'ttag';

// eslint-disable-next-line import/prefer-default-export
export const fixedFields = () => [
  { id: 'firstName', label: t`First Name`, type: 'text', value: ({ person }) => person.firstName },
  { id: 'lastName', label: t`Last Name`, type: 'text', value: ({ person }) => person.lastName },
  { id: 'company', label: t`Company`, type: 'text', value: ({ person }) => person.companyName },
  { id: 'title', label: t`Title/Position`, type: 'text', value: ({ person }) => person.title },
];
